import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import { ApiPatchOperation } from '@root/@types/types';
import axios from 'axios';

interface BatchCloneEndorsementInput {
  submissionId: string;
  endorsementId: string;
  contractIds: string[];
}

export const batchCloneEndorsement = async (input: BatchCloneEndorsementInput) => {
  const { submissionId, endorsementId, contractIds } = input;

  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url: `submissions/${submissionId}/endorsements/${endorsementId}`,
    data: { operation: ApiPatchOperation.BatchCloneEndorsement, targetSubmissionIds: contractIds },
  });

  const response = await axios(networkPayload);
  return response.data;
};
